import FootprintFormCar from "../../components/FootprintForm/FootprintFormCar"
import Footer from '../../components/Footer/Footer'
import './FootprintPages.css'

const FootprintPage = () => {

    return (
        <>
            <FootprintFormCar />
            <Footer />

        </>
    )
}

export default FootprintPage